<template>

    <div class="overflow-hidden shadow-md rounded-lg">

        <div class="grid w-full"
             style="height: 50px; background-color: #F9FAFB;"
             :style="`
                grid-template-columns: ${columns};
                grid-template-rows: 50px;
                align-items: center;
             `">

            <div class="px-6" style="background-color: #F9FAFB;" v-for="header in widget_headers">

                {{ header.title }}

            </div>

        </div>

        <div class="overflow-x-hidden overflow-y-scroll bg-white grid w-full"
             style="height:calc(100% - 50px);"
             :style="`
                grid-template-columns: ${columns};
                grid-template-rows: repeat(${ widget_content.length }, 50px 2px);
                align-items: center;
             `">

            <div v-for="(content,index) of widget_content"
                 :key="content.id"
                 class="contents w-full">

                <div v-if="options" class="px-6 w-full truncate">

                    {{ index + 1 }}. {{ content.title }}

                </div>

                <div v-else class="px-6 w-full truncate">

                    {{ content.title }}

                </div>

                <div v-if="'sent_to' in content" class="px-6">{{ input_short(content.sent_to) }}</div>

                <div class="px-6 w-full">{{ input_short(content.clicks) }}</div>

                <div class="border-b-2 border-b-gray-300 bg-white h-full"
                    style="margin: 0 -1.5rem 0 -1.5rem;"
                    :style="'grid-column: span ' + widget_headers.length + ' / span ' + widget_headers.length"
                    v-if="index !== widget_content.length - 1">
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import {defineComponent} from "vue";
export default defineComponent({
    name: "ListWidget",

    props: {
        widget_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        title: 'Title',
                    }
                ]
            }
        },
        widget_content: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        title: "The Nordic Council's environmental award",
                        clicks: 2500,
                        sent_to: '',
                    },
                    {
                        id: 2,
                        title: "The Nordic Council's environmental award",
                        clicks: 2500,
                        sent_to: '',
                    },
                ];
            }
        },
        columns: {
            type: String,
            default: '4fr 0.7fr 0.7fr',
        },
        options: {
            type: Boolean,
            default: false
        }
    },

    computed: {
    },
    methods: {
      input_short(input) {

          return Math.abs(input) > 999 ? Math.sign(input)*((Math.abs(input)/1000).toFixed(1)) +
              'k' : Math.sign(input)*Math.abs(input);

      }
    }
})
</script>

<style scoped>

</style>
